import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/home.vue'
import AuthPage from '@/pages/auth.vue'
import Logout from '@/pages/logout.vue'
import LetoAuth from '@/pages/leto-auth.vue'
import { useHelpers } from '@/composables/useHelpers'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/auth',
      name: 'auth',
      component: AuthPage,
      meta: { guest: true }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/leto',
      name: 'leto-auth',
      component: LetoAuth
    }

    // {
    //   path: '/:pathMatch(.*)*',
    //   name: 'widcard',
    //   component: Home,
    //   meta: { requiresAuth: true }
    // }
  ]
})

router.beforeEach((to, _from, next) => {
  const { getCookie } = useHelpers()
  const requiresAuth = to.matched.some(record => record.meta?.requiresAuth)
  const guest = to.matched.some(record => record.meta?.guest)
  const token = getCookie('access_token')

  if (requiresAuth && !token) {
    return next({ name: 'auth', query: { redirect: to.fullPath } })
  }

  if (token && guest) {
    return next({ name: 'home' })
  }

  return next()
})

export default router
